import {Periodo} from "./Periodo";
import {Column, Entity, LineString, OneToMany, PrimaryGeneratedColumn} from "typeorm/browser";
import {Monitoramento} from "./Monitoramento";
import { Location} from "@capacitor-community/background-geolocation";
import {Entidade} from "./Entidade";
@Entity("jornada")
export class Jornada  extends Entidade{
  @Column("datetime")
  inicio?: Date
  @Column("datetime")
  fim?: Date
  @Column()
  pausado?: boolean
  // @Column({spatialFeatureType: "linestring"})
  @Column("simple-json")
  pontos?: LineString
  // @Column("simple-json")
  // pontos?: Location[]
  @Column()
  duracao: number = 0
  @Column({type: "simple-json", array: true})
  periodos?: Periodo[]

  @OneToMany(() => Monitoramento, (monitor) => monitor.jornada, {cascade: true, })
  monitoramentos?: Monitoramento[]

  @Column()
  agencia_sigla?: string

}


